import { ReactNode } from 'react';

import { ToasterService } from '../Toaster/ToasterService';

export const WATCHLIST_MESSAGES = {
  addToWatchlistMessage: 'Vehicle has been added to your watchlist.',
  addToWatchlistTooManyErrorMessage:
    "You've added 250 cars to your watchlist. To add more, please remove another first.",
  addToWatchlistGenericErrorMessage: 'Failed to add vehicle to your watchlist.',
  removeFromWatchlistMessage: 'Vehicle has been removed from your watchlist.',
};

export type LabelsOverwrite = {
  save: ReactNode;
  saved: ReactNode;
};

export const getButtonLabel = (userAddedItem: boolean, labelsOverwrite?: LabelsOverwrite) => {
  if (userAddedItem) {
    return labelsOverwrite ? labelsOverwrite.saved : 'Saved';
  }

  return labelsOverwrite ? labelsOverwrite.save : 'Save';
};

export const generateSourceString = (pathname: string) => {
  if (pathname === '/') {
    return 'HOME';
  }
  if (pathname.includes('/used-cars')) {
    return 'PLP';
  }
  if (pathname.includes('/product-detail')) {
    return 'PDP';
  }
  if (pathname.includes('/watchlist')) {
    return 'WATCHLIST';
  }

  return undefined;
};

export const displayAddWatchListItemToast = () => {
  ToasterService.success({ message: WATCHLIST_MESSAGES.addToWatchlistMessage });
};

export const displayRemoveWatchListItemToast = (onUndo: () => void) => {
  ToasterService.info({
    message: WATCHLIST_MESSAGES.removeFromWatchlistMessage,
    action: { type: 'undo', onAction: onUndo },
  });
};

export const getFullRedirectUrl = (sku: string, pathname: string) => {
  if (typeof window === 'undefined') return '';
  const redirectUrl = new URL(window.location.toString());
  redirectUrl.searchParams.append('watchlistSku', sku);
  const queryParams = new URLSearchParams({
    type: 'watchlist',
    sku: sku,
    source: `${generateSourceString(pathname ?? '')}`,
    redirect: redirectUrl.toString(),
    origin: redirectUrl.toString(),
  });
  return `/forms/-/auth/start?${queryParams.toString()}`;
};
